module.exports = __webpack_public_path__ + "img/14.147f861f.jpg";